import React, {useMemo, useState, useEffect, useCallback} from 'react'
import {Carousel} from 'react-bootstrap'
import {Link, useLocation} from 'react-router-dom'
import {FormattedMessage, useIntl} from 'react-intl'
import {toAbsoluteUrl, StorageHelpers} from '../../../../_gori/helpers'
import {TermsModal} from '../../orders/modals/TermsModal'
import {ROUTES} from '../../../../_gori/constants'
import {
  // MARKET_PROMO_BANNER_VISIBLE_KEY,
  // TEMU_BANNER_VISIBLE_KEY,
  BAEGUARD_BANNER_VISIBLE_KEY,
} from '../../../../_gori/constants'
import clsx from 'clsx'

interface CarouselItem {
  id: string
  iconPath: string
  iconAlt: string
  iconWidth?: number
  titleKey?: string
  textKey?: string
  buttonKey: string
  termsButtonKey: string
  linkTo: string
  showTermsButton?: boolean
  theme?: 'default' | 'temu'
  textColor?: string
  backgroundColor?: string
  buttonColor?: string
  buttonTextColor?: string
  customContent?: React.ReactNode
  external?: boolean
}

interface AnnouncementCarouselProps {
  eligible?: boolean
  items?: CarouselItem[]
  showOnlyOnOrders?: boolean
}

const VIS_KEY_BY_ID: Record<string, string> = {
  'baeguard-promo': BAEGUARD_BANNER_VISIBLE_KEY,
  // 'market-promo': MARKET_PROMO_BANNER_VISIBLE_KEY,
  // 'temu-promo': TEMU_BANNER_VISIBLE_KEY,
}
const keyForId = (id: string) => VIS_KEY_BY_ID[id] ?? `ANNOUNCEMENT_CLOSED_${id}`

const AnnouncementCarousel: React.FC<AnnouncementCarouselProps> = ({
  eligible = true,
  items,
  showOnlyOnOrders = true,
}) => {
  const intl = useIntl()
  const location = useLocation()
  const isOrdersPage = location.pathname === '/orders'

  const [showTermsModal, setShowTermsModal] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const [isVisible, setIsVisible] = useState(true)

  const defaultItems = useMemo(() => {
    const data: CarouselItem[] = [
      {
        id: 'baeguard-promo',
        titleKey: '',
        theme: 'default',
        backgroundColor: '#1367AB',
        textColor: '#FFFFFF',
        buttonColor: '#18517F',
        buttonTextColor: '#FFFFFF',
        iconPath: '/media/gori/promotions/baeguard/baeguard-shield.svg',
        iconAlt: 'BaeGuard',
        iconWidth: 80,
        textKey: 'BAEGUARD_PROMOTION_CAROUSEL_TEXT',
        buttonKey: 'BUTTON_KEY_AUTO_BAEGUARD',
        linkTo: ROUTES.SETTINGS.INSURANCE,
        termsButtonKey: 'BAEGUARD_PROMOTION_CAROUSEL_TERMS_FOR_DETAILS',
        showTermsButton: false,
        customContent: (
          <div className='baeguard-content d-flex flex-column align-items-center'>
            {/* Shield + Wordmark logo */}
            <div className='baeguard-logo-wrap'>
              <img
                src={toAbsoluteUrl('/media/gori/promotions/baeguard/baeguard-shield.svg')}
                alt='BaeGuard Shield'
                className='baeguard-shield'
              />
              <img
                src={toAbsoluteUrl('/media/logos/baeguard-logo-white.svg')}
                alt='BaeGuard'
                className='baeguard-wordmark'
              />
            </div>
            {/* ≥1440: two-line layout */}
            <div className='baeguard-text-area baeguard-text-area--desktop flex-column align-items-center text-center text-white'>
              <p className='baeguard-headline m-0'>
                <FormattedMessage id='BAEGUARD_CAROUSEL_HEADLINE' />
              </p>
              <div className='baeguard-subline d-flex gap-4 align-items-center'>
                <span className='baeguard-subtext'>
                  <FormattedMessage id='BAEGUARD_CAROUSEL_SUBTEXT' />
                </span>
                <a href={ROUTES.HELP_CENTER.BAE_GUARD} className='baeguard-learn-more text-white'>
                  <FormattedMessage id='LEARN_MORE' />
                </a>
              </div>
            </div>
            {/* <1440: merged single-line + learn more below */}
            <div className='baeguard-text-area baeguard-text-area--laptop flex-column align-items-center text-center text-white'>
              <p className='baeguard-main-text m-0'>
                <FormattedMessage id='BAEGUARD_SETTING_AUTO_CONTENT_2' />
                {'. '}
                <FormattedMessage id='BAEGUARD_CAROUSEL_SUBTEXT' />
              </p>
              <a href={ROUTES.HELP_CENTER.BAE_GUARD} className='baeguard-learn-more text-white'>
                <FormattedMessage id='LEARN_MORE' />
              </a>
            </div>
          </div>
        ),
      },
      // {
      //   id: 'market-promo',
      //   theme: 'default',
      //   backgroundColor: '#0B6D65',
      //   textColor: '#FFFFFF',
      //   iconPath: '/media/gori/promotions/MarketPromoShopIcon.svg',
      //   iconAlt: 'Meter +$50',
      //   iconWidth: 229,
      //   textKey: 'MARKETPLACE_PROMOTION_CAROUSEL_TEXT',
      //   buttonKey: 'MARKETPLACE_PROMOTION_CAROUSEL_BUTTON',
      //   linkTo: ROUTES.SETTINGS.CONNECTIONS.BASE,
      //   termsButtonKey: 'MARKETPLACE_PROMOTION_CAROUSEL_TERMS_FOR_DETAILS',
      //   showTermsButton: true,
      //   titleKey: '',
      //   buttonTextColor: '',
      // },
      // {
      //   id: 'temu-promo',
      //   theme: 'temu' as const,
      //   backgroundColor: '#fffbeb',
      //   textColor: '#1E2A3B',
      //   iconPath: '/media/logos/temu.svg',
      //   iconAlt: 'Temu Logo',
      //   iconWidth: 130,
      //   titleKey: '',
      //   textKey: 'TEMU_PROMOTION_CAROUSEL_TEXT',
      //   buttonKey: 'TEMU_CAROUSEL_BUTTON',
      //   linkTo: ROUTES.INTEGRATIONS.TEMU,
      //   termsButtonKey: '',
      //   showTermsButton: false,
      //   buttonTextColor: '',
      //   buttonColor: '#FB7701',
      //   customContent: (
      //     <div className='temu-carousel-content'>
      //       <img
      //         src={toAbsoluteUrl(
      //           '/media/gori/promotions/temu-promo/temu_integ_circles_full_bg.svg'
      //         )}
      //         alt=''
      //         className='temu-carousel-circle'
      //       />
      //       <div className='temu-carousel-logo'>
      //         <img
      //           src={toAbsoluteUrl('/media/gori/integrations/temu/temu-logo.webp')}
      //           alt='Temu'
      //           className='temu-carousel-icon'
      //         />
      //         <div className='temu-carousel-label'>
      //           <span>
      //             <FormattedMessage id='TEMU_CAROUSEL_LABEL_1' />
      //           </span>
      //           <span>
      //             <FormattedMessage id='TEMU_CAROUSEL_LABEL_2' />
      //           </span>
      //         </div>
      //       </div>
      //       <p className='temu-carousel-title'>
      //         <FormattedMessage id='TEMU_CAROUSEL_HEADLINE' />
      //       </p>
      //     </div>
      //   ),
      // },
    ]

    return data
  }, [])

  const allItems = items ?? defaultItems

  const visibleItems = useMemo(() => {
    return allItems.filter((it) => {
      const key = keyForId(it.id)
      const v = StorageHelpers.getItemCookies(key)
      if (VIS_KEY_BY_ID[it.id]) return v !== 'false'
      return v !== 'true'
    })
  }, [allItems])

  useEffect(() => {
    if (activeIndex > visibleItems.length - 1) {
      setActiveIndex(Math.max(0, visibleItems.length - 1))
    }
  }, [visibleItems.length, activeIndex])

  const handleCloseCarousel = useCallback((item: CarouselItem) => {
    const key = keyForId(item.id)
    if (VIS_KEY_BY_ID[item.id]) {
      StorageHelpers.setItemCookies(key, 'false', {expires: 365})
    } else {
      StorageHelpers.setItemCookies(key, 'true', {expires: 365})
    }
    setIsVisible(false)
  }, [])

  const shouldRender =
    eligible && (!showOnlyOnOrders || isOrdersPage) && visibleItems.length > 0 && isVisible

  if (!shouldRender) return null

  const customChevron = toAbsoluteUrl('/media/gori/promotions/chevron-right-custom.svg')
  const swirlyArrow = toAbsoluteUrl('/media/gori/promotions/temu-promo/swirly-arrow.webp')

  return (
    <>
      <div className='announcement-carousel-container mb-4 fade-in'>
        <Carousel
          interval={5000}
          indicators={visibleItems.length > 1}
          controls={visibleItems.length > 1}
          fade={false}
          className='announcement-carousel mt-10 mt-xxl-0'
          activeIndex={activeIndex}
          onSelect={(idx) => setActiveIndex(idx)}
        >
          {visibleItems.map((item) => (
            <Carousel.Item key={item.id}>
              <div
                className='carousel-item-container d-flex align-items-center justify-content-between'
                style={{backgroundColor: item.backgroundColor || '#0B6D65'}}
              >
                <div className='carousel-layout d-flex flex-column align-items-center justify-content-between gap-8 text-white text-center w-100'>
                  {item.customContent ? (
                    item.customContent
                  ) : (
                    <>
                      <div
                        className={clsx(
                          'd-flex flex-row justify-content-center align-items-center',
                          {
                            'carousel-rings-container': item.id === 'temu-promo',
                          }
                        )}
                        style={
                          item.id === 'temu-promo'
                            ? {
                                ['--temu-full-rings' as any]: `url(${toAbsoluteUrl(
                                  '/media/gori/promotions/temu-promo/temu_integ_circles_full_bg.svg'
                                )})`,
                              }
                            : {}
                        }
                      >
                        <img
                          className='carousel-icon'
                          src={toAbsoluteUrl(item.iconPath)}
                          alt={item.iconAlt || 'Graphic'}
                          width={item.iconWidth || 229}
                          style={{minWidth: item.iconWidth || 229, maxWidth: item.iconWidth || 229}}
                        />
                        {item.titleKey && (
                          <p
                            className='carousel-title m-0 text-nowrap'
                            style={{color: item.textColor || '#FFF'}}
                            dangerouslySetInnerHTML={{
                              __html: intl.formatMessage({id: item.titleKey}),
                            }}
                          ></p>
                        )}
                      </div>

                      <div
                        className='carousel-text-wrapper'
                        style={{color: item.textColor || '#FFFFFF'}}
                      >
                        <p className='carousel-text m-0'>
                          {item.theme === 'temu' ? (
                            <span
                              className='temu-text'
                              dangerouslySetInnerHTML={{
                                __html: intl.formatMessage({id: item.textKey}),
                              }}
                            ></span>
                          ) : (
                            <FormattedMessage
                              id={item.textKey || 'MARKETPLACE_PROMOTION_CAROUSEL_TEXT'}
                              values={{
                                span: (chunks: React.ReactNode) => (
                                  <span className='highlighted-text'>{chunks}</span>
                                ),
                                smaller: (chunks: React.ReactNode) => (
                                  <span className='smaller-text'>{chunks}</span>
                                ),
                              }}
                            />
                          )}
                        </p>
                      </div>
                    </>
                  )}

                  <div className='buttons d-flex align-items-center justify-content-flex-end gap-12'>
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                      {(() => {
                        const btnClass = clsx(
                          'position-relative btn-color btn btn-outline btn-primary-deep rounded-pill text-center d-block w-fit-content custom-button text-nowrap',
                          {
                            'carousel-btn-offset': item.showTermsButton === true,
                            'btn-marketplace-promo-light-teal':
                              item.theme === 'default' &&
                              item.id !== 'baeguard-promo' &&
                              item.id !== 'baeguard-setting-promo' &&
                              !item.buttonColor,
                            'webinar-button': item.id === 'temu-promo' && item.theme === 'default',
                            'btn-temu-orange hover-orange': item.theme === 'temu',
                            'swirly-arrow': item.theme === 'temu',
                            'baeguard-button':
                              item.id === 'baeguard-promo' || item.id === 'baeguard-setting-promo',
                          }
                        )
                        const btnStyle = {
                          ['--swirly-arrow' as any]: `url(${swirlyArrow})`,
                          ...(item.buttonColor && {
                            backgroundColor: item.buttonColor,
                            borderColor: item.buttonColor,
                          }),
                          ...(item.buttonTextColor && {color: item.buttonTextColor}),
                        }
                        const btnContent = (
                          <>
                            {intl.formatMessage({
                              id: item.buttonKey || 'MARKETPLACE_PROMOTION_CAROUSEL_BUTTON',
                            })}
                            <span
                              className='ms-1 promo-chevron'
                              style={{
                                ['--custom-chevron' as any]: `url(${customChevron})`,
                              }}
                              aria-hidden='true'
                            />
                          </>
                        )
                        return item.external ? (
                          <a
                            href={item.linkTo}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={btnClass}
                            style={btnStyle}
                          >
                            {btnContent}
                          </a>
                        ) : (
                          <Link to={item.linkTo} className={btnClass} style={btnStyle}>
                            {btnContent}
                          </Link>
                        )
                      })()}

                      {item.showTermsButton && (
                        <button
                          type='button'
                          className={clsx('btn btn-link btn-sm text-decoration-underline mt-2', {
                            'text-white': item.theme === 'default',
                          })}
                          onClick={() => setShowTermsModal(true)}
                        >
                          {intl.formatMessage({
                            id:
                              item.termsButtonKey ||
                              'MARKETPLACE_PROMOTION_CAROUSEL_TERMS_FOR_DETAILS',
                          })}
                        </button>
                      )}
                    </div>

                    <button
                      className='close-btn'
                      onClick={() => handleCloseCarousel(item)}
                      aria-label='Close'
                    >
                      <img
                        src={
                          item.textColor && item.textColor !== '#FFFFFF'
                            ? toAbsoluteUrl('/media/gori/promotions/x-black.svg')
                            : toAbsoluteUrl('/media/gori/promotions/x-white.svg')
                        }
                        alt='X'
                        width={24}
                      />
                    </button>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <TermsModal show={showTermsModal} handleClose={() => setShowTermsModal(false)} />
    </>
  )
}

export {AnnouncementCarousel}
export type {CarouselItem}
